import {createLoaderWorker} from '../lib/worker-loader-utils/create-loader-worker';
import {JSONLoader} from '../json-loader';

createLoaderWorker(JSONLoader);
